import get from "lodash.get";

import { Video } from "~types/types";

type AdOptions = {
    adCustomParams: string;
    adCodePrefix: string;
};

export const getVerticalVideoPlayerOptions = (video: Video) => {
    const { url, autoplay = false } = video;

    return {
        aspectRatio: "2:3",
        autoplay,
        start_muted: false,
        log_debug: false,
        comscore_ns_site: "bloomberg",
        use_share_overlay: true,
        share_metadata: {
            canonical_url: url,
        },
        use_google_tag_manager: true,
        asset_protocol: "https",
        vertical: "business",
        zone: "article",
        useFoundationLayout: true,
        usePhoenixTheme: true,
        fillContainer: true,
        fillPosition: "top",
        intrinsicAspectRatio: "9:16",
        pauseOnBlur: false,
        controlBar: {
            children: [
                "playToggle",
                "progressControl",
                "customControlSpacer",
                "captionsButton",
                {
                    name: "volumePanel",
                    inline: false,
                },
                "fullscreenToggle",
            ],
        },
    };
};

export const getVideoPlayerOptions = (
    video: Video,
    location: string,
    isJapanese = false
) => {
    const { url, autoplay = false } = video;
    const customParams = `autoplay=${autoplay}&ni=&suid=US&location=${location}&template=article&page=articlejav`;
    const serviceEnv = "production";
    const isClient = typeof window !== "undefined";

    const options = {
        serviceEnv,
        autoplay,
        loadSuggestions: !isJapanese,
        module_ad_player: "true",
        ad_tag: isJapanese ? "japan/vod" : "",
        ad_tag_gpt_preroll: true,
        ad_tag_gpt_midroll: true,
        ad_tag_sz_preroll: "1x7",
        ad_tag_sz_midroll: "1x7",
        ad_tag_midroll: "business/midroll/vod",
        ad_tag_overlay: "business/videooverlay",
        ad_network_id_preroll: "5262",
        ad_network_id_midroll: "5262",
        ad_tag_cust_params_midroll: customParams,
        log_debug: false,
        comscore_ns_site: "bloomberg",
        use_share_overlay: true,
        share_metadata: {
            canonical_url: url,
        },
        use_google_tag_manager: true,
        asset_protocol: "https",
        vertical: "business",
        zone: "article",
        useFoundationLayout: true,
    };

    if (isClient) {
        const adOptions: AdOptions = getAdOpsTestParams(window.location.search);
        const parselyPageUrl = window.location.href;

        return {
            ...options,
            parselyPageUrl,
            ad_code_prefix: adOptions.adCodePrefix,
            ad_tag_cust_params_preroll: `${customParams}${adOptions.adCustomParams}`,
            ad_tag_cust_params_midroll: `${customParams}${adOptions.adCustomParams}`,
        };
    }

    return options;
};

// TODO: we still need clarity from Ads if this code is still used. Will leave it unchanged from Javelin for now.
function getAdOpsTestParams(queryString: string): AdOptions {
    const adOpsParams = ["test", "demo", "bpop", "adv", "tagr", "cmpid"];
    const adCodePrefix = getQueryStringValue(queryString, "ad_test");
    const adCustomParams = adOpsParams.reduce((sum, paramName) => {
        const paramValue = getQueryStringValue(queryString, paramName);

        return sum + (paramValue ? `&${paramName}=${paramValue}` : "");
    }, "");

    return {
        adCustomParams,
        adCodePrefix,
    };
}

// TODO: we still need clarity from Ads if this code is still used. Will leave it unchanged from Javelin for now.
function getQueryStringValue(queryString: string, paramName: string) {
    const regex = new RegExp(`(^|\\?|&)${paramName}=([^&]+)`);

    return get(regex.exec(queryString), 2, "");
}
